<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllAssetList('printAssetList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllAsset()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Depreciation code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.branchId"
                :items="branchList"
                color="blue-grey lighten-2"
                label="Choose Branch..."
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                :readonly="checkUserBranch() ? true : false"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="shopCode"
                label="Shop Code"
                type="text"
                v-model="queryParams.shopCode"
                :readonly="checkUserShop() ? true : false"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.departmentId"
                :items="departmentList"
                color="blue-grey lighten-2"
                label="Choose Department..."
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="assetName"
                label="Asset Name"
                type="text"
                v-model="queryParams.assetName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="assetType"
                label="Asset Type"
                type="text"
                v-model="queryParams.assetType"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="accountName"
                label="Account Name"
                type="text"
                v-model="queryParams.accountName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="assetList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.depreciationStatus }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.branchName }}</td>
              <td>{{ props.item.shopCode }}</td>
              <td>{{ props.item.departmentName }}</td>
              <td>{{ props.item.assetName }}</td>
              <td>{{ props.item.assetType }}</td>
              <td>{{ props.item.chartOfAccountName }}</td>
              <td>{{ props.item.depreciationMethod }}</td>
              <td>
                <span v-if="props.item.depreciationType == 'MONTHLY'"
                  >Monthly</span
                >
              </td>
              <td style="text-align: center;">{{ props.item.recoveryPeriod }}</td>
              <td>{{ props.item.startPeriod | format-month }}</td>
              <td>{{ props.item.endPeriod | format-month }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all-->
    <div
      id="printAssetList"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px; font-weight: bold">
          {{ queryParams.shopCode }}
        </p>
      </div>
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px">Asset</p>
      </div>
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px">
          From [{{ fDate }}] to [{{ tDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Depreciation Code</th>
              <th style="text-align: left">Branch</th>
              <th style="text-align: left">Shope Code</th>
              <th style="text-align: left">Department</th>
              <th style="text-align: left">Asset Name</th>
              <th style="text-align: left">Account Name</th>
              <th style="text-align: left">Method</th>
              <th style="text-align: left">Type</th>
              <th style="text-align: left">Period(Month)</th>
              <th style="text-align: left">Start Period</th>
              <th style="text-align: left">End Period</th>
              <th style="text-align: left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allAssetList" :key="index">
              <td style="text-align: left">{{ item.code }}</td>
              <td style="text-align: left">{{ item.branchName }}</td>
              <td style="text-align: left">{{ item.shopCode }}</td>
              <td style="text-align: left">{{ item.departmentName }}</td>
              <td style="text-align: left">{{ item.assetName }}</td>
              <td style="text-align: left">{{ item.assetType }}</td>
              <td style="text-align: left">{{ item.chartOfAccountName }}</td>
              <td style="text-align: left">{{ item.depreciationMethod }}</td>
              <td style="text-align: left">
                <span v-if="item.depreciationType == 'MONTHLY'">Monthly</span>
              </td>
              <td style="text-align: left">{{ item.recoveryPeriod }}</td>
              <td style="text-align: left">
                {{ item.startPeriod | format-month }}
              </td>
              <td style="text-align: left">
                {{ item.endPeriod | format-month }}
              </td>
              <td style="text-align: left">{{ item.depreciationStatus }}</td>
            </tr>
          </tbody>
        </table>
        <div style="height: 10px"></div>
      </div>
    </div>
    <assetExcel :isOpen="openDialog" v-on:change="dialogClose()"></assetExcel>
  </v-container>
</template>

<script>
import { assetService } from "../../services/asset-service";
import { commonService } from "../../services/common-service";
import { branchService } from "../../services/branch-service";
import { departmentService } from "../../services/department-service";
import assetExcel from "../../components/asset/AssetExcel";

export default {
  name: "AssetList",
  components: { assetExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    buttonLoading: false,
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Asset",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "depreciationStatus" },
      { text: "Depreciation Code", align: "left", value: "code" },
      { text: "Branch", value: "branch.name" },
      { text: "Shop Code", value: "shop.code" },
      { text: "Department", value: "department.name" },
      { text: "Asset Name", value: "assetName" },
      { text: "Asset Type", value: "assetType" },
      { text: "Account Name", value: "chartOfAccount.accName" },
      { text: "Method", value: "depreciationMethod" },
      { text: "Type", value: "depreciationType" },
      { text: "Period(Month)", value: "recoveryPeriod" },
      { text: "Start Period", value: "startPeriod" },
      { text: "End Period", value: "endPeriod" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
      { label: "DISPOSAL", value: "DISPOSAL" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      status: "",
      code: "",
      shopCode: "",
      accountName: "",
      branchId: "",
      departmentId: "",
      assetType: "",
      assetName: "",
    },
    openDialog: false,
    assetList: [],
    allAssetList: [],
    branchList: [],
    departmentList: [],
    totalRows: 0,
    fDate: "",
    tDate: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getAssetList();
      },
      deep: true,
    },
  },
  created() {
    this.getActiveBranchList();
    this.getActiveDepartmentList();
    this.queryParams.shopCode = this.checkUserShop();

    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.branchId) {
      this.queryParams.branchId = Number(this.$route.query.branchId);
    }
    if (this.$route.query.shopCode) {
      this.queryParams.shopCode = this.$route.query.shopCode;
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = Number(this.$route.query.departmentId);
    }
    if (this.$route.query.assetType) {
      this.queryParams.assetType = this.$route.query.assetType;
    }
    if (this.$route.query.assetName) {
      this.queryParams.assetName = this.$route.query.assetName;
    }
    if (this.$route.query.accountName) {
      this.queryParams.accountName = this.$route.query.accountName;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    checkUserBranch() {
      // if (this.user.role.roleName == "ASSET_MANAGER") {
      //   return this.user.branchId;
      // } else {
      //   return "";
      // }
      return "";
    },
    checkUserShop() {
      if (this.user.role.roleName == "ASSET_MANAGER") {
        return this.user.shop.code;
      } else {
        return "";
      }
    },
    getActiveBranchList() {
      branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
          this.branchList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "assets", query: this.queryParams });
      this.getAssetList();
    },
    getAssetList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      assetService
        .getAssetList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.assetList = res.data.assetList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/asset/new");
    },
    onEdit(asset) {
      // go to details page
      this.$router.push("/asset/" + asset.id);
    },
    exportAllAsset() {
      this.buttonLoading = true;
      assetService
        .getAssetExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getAssetList();
    },
    printAllAssetList(divName) {
      this.buttonLoading = true;
      assetService
        .getAllAssetist(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allAssetList = res.data.assetList;
            this.totalRows = res.data.totalElements;
            this.fDate = commonService.formatDate(
              this.queryParams.fromDate,
              "DD-MM-YYYY"
            );
            this.tDate = commonService.formatDate(
              this.queryParams.toDate,
              "DD-MM-YYYY"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>